import React from "react";
import styles from "./AgentTransitionSeparator.module.css";

interface AgentTransitionSeparatorProps {
    agentName: string;
}

export const AgentTransitionSeparator: React.FC<AgentTransitionSeparatorProps> = ({agentName}) => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.line}/>
            <span className={styles.transitionText}>{agentName}</span>
            <div className={styles.line}/>
        </div>
    )
}
